import { useLayoutEffect } from "react";
import { useRouterState } from "@tanstack/react-router";
import { closeRazorpayNow } from "@/lib/razorpayTeardown";

/** Closes body-level checkout UI synchronously whenever the app changes page. */
export function PaymentRouteCleanup() {
  const locationKey = useRouterState({
    select: (state) => `${state.location.pathname}${state.location.searchStr ?? ""}`,
  });

  // Layout effect runs before the destination paints, so checkout cannot flash
  // over the first frame of the next page.
  useLayoutEffect(() => {
    closeRazorpayNow();
  }, [locationKey]);

  return null;
}